import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Rename `generated` to `frozen` for every script
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v9---')

  const scriptStore = transaction.objectStore('scripts')

  // First, we get all scripts
  const scriptsRequest = scriptStore.getAll()
  scriptsRequest.onsuccess = () => {
    const scripts = scriptsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all scripts', scripts)

    // Then, for each script, set the `frozen` prop
    asyncForEach(
      scripts,
      (script, next) => {
        STUDIO_ENV_DEVELOPMENT && console.log('Updating script', script)
        script.frozen = script.generated
        delete script.generated
        scriptStore.put(script).onsuccess = next
      },
      () => {
        STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v9---')
        return next()
      }
    )
  }
}
